import { useEffect, useState } from 'react';
import { message } from 'antd';
import { GetAgentById } from '@/apis/settings';
import { useSpin } from '@/components/SpinContext';
import { EditAgent } from '../types';

export const useAgentDetails = ({
  drawerOpen,
  token,
  agentId,
}: {
  drawerOpen: boolean;
  token?: string | null;
  agentId?: string | number | null;
}) => {
  const { showSpin, hideSpin } = useSpin();
  const [editAgent, setEditAgent] = useState<EditAgent | null>(null);

  useEffect(() => {
    if (!drawerOpen || !token) return;

    if (!agentId) {
      setEditAgent(null);
      return;
    }

    showSpin();
    GetAgentById(token, String(agentId))
      .then((res) => {
        const data = res?.data?.data?.data as EditAgent | undefined;
        setEditAgent(data ?? null);
      })
      .catch(() => {
        message.error('Failed to load agent details');
        setEditAgent(null);
      })
      .finally(() => hideSpin());
  }, [drawerOpen, token, agentId, showSpin, hideSpin]);

  return { editAgent };
};
